import { commonChecks, getBrowserVersion } from '@xhs/ozone-detector'

let XHS_VERSION = '0'

if (commonChecks.isXHS) {
  const { major, minor, patch } = getBrowserVersion()

  XHS_VERSION = `${major}.${minor}.${patch}`
}

function coerce(version) {
  const versionList = version.split('.').map(str => Number.parseInt(str, 10))

  return [versionList[0] || 0, versionList[1] || 0, versionList[2] || 0]
}

function compare(a, b) {
  const aList = coerce(a)
  const bList = coerce(b)
  let equalTime = 0

  for (let i = 0; i < 3; i++) {
    if (aList[i] > bList[i]) {
      return 1
    } if (aList[i] === bList[i]) {
      equalTime += 1
    }
  }

  if (equalTime === 3) {
    return 0
  }

  return -1
}

function appVersionLt(v) {
  return compare(XHS_VERSION, v) < 0
}

function appVersionGte(v) {
  return !appVersionLt(v)
}

function appVersionEq(v) {
  return compare(XHS_VERSION, v) === 0
}

export {
  appVersionLt,
  appVersionGte,
  appVersionEq,
}
